import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import AbuseReportPage from './pages/AbuseReportPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AbuseReportPage />} />
      </Routes>
    </Router>
  );
}

export default App;